import type { UUID } from "@/core/types";

export const patientDetailKeys = {
  activities: (id: UUID) => [...patientDetailKeys.details(id), "activities"] as const,
  base: ["patient"] as const,
  details: (id: UUID) => [...patientDetailKeys.base, id, "details"] as const,
  diagnosis: (id: UUID) => [...patientDetailKeys.details(id), "diagnosis"] as const,
} as const;
